import { roundToEndOfDay as roundMidnight } from "b2b/utils/date";

export default {
  format: value =>
    value ? roundMidnight(new Date(value)).getTime() : undefined,
  unformat: value =>
    value ? roundMidnight(new Date(value)).getTime() : undefined
};
